export enum ReportDataTypeEnum {
    DataRequest = 'DataRequest',
    ListingRequest = 'ListingRequest',
    DataSet = 'DataSet',
    Enquiry = 'Enquiry',
    DuaDetail = 'DuaDetail',
    Disclosure = 'Disclosure',
    ResearchTeam = 'ResearchTeam',
}
